import { IResetUserPassword } from './../../typings/board/Models';
import { IQService, IHttpService, noop } from 'angular';
export const RESET_PASSWORD_SERVICE = "resetPasswordService";

export class ResetPasswordService {
    static $inject = ["$q", "$http"];
    constructor(private $q: IQService, private $http: IHttpService) { }

    resetPassword(id: string, password: string, confirm: string, ticket: string) {
        if (confirm != password) {
            return this.$q.reject("Password and confirm password doesn't match.");
        }

        return this.$http.post<void>("api/resetpassword/resetpassword", {
            userId: id,
            password: password,
            ticket: ticket
        } as IResetUserPassword).then(
            noop,
            reason => this.$q.reject(reason.data.message));
    }
}


// WEBPACK FOOTER //
// ./app/reset-password/reset-password.service.ts